export enum ButtonAccent {
  AccentDefault = "",
  AccentOrange = "accent-orange",
  AccentOrangeFocusVisible = "accent-orange-focus-visible",
  AccentGrey = "accent-grey",
}
